module.exports = __webpack_public_path__ + "img/sj5.2905bae7.png";